// extracted by mini-css-extract-plugin
module.exports = {"infiniteCycle":"_1iuk3MiBYxIFQeh_1ssaq-","imgMulticolorIcon":"_14ikAX5IZcEhs8nCM6J8rn"};